module.exports = __webpack_public_path__ + "static/media/icon_search.22fcca2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_search.svg
// module id = 2421
// module chunks = 7